import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { LayoutProps } from '../../types';

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#1A1A2E' }}>
      <Header />
      <main style={{ flex: 1, position: 'relative' }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;